import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/* =========================
   CARD DATA
========================= */

const cards = [
  {
    title:
      "How Restaurants and QSRs Can Motivate Their Employees to Return to Work and Improve Diners’ Experiences",
    image:
        "https://assets.dailypay.com/wp-content/uploads/Rest-QSR_Supply-Delays-and-Shortages.png",

    type: "BLOG",
  },

  {
    title:
      "Restaurants and QSRs Can Attract More Customers With New Technology",
    image:
"https://assets.dailypay.com/wp-content/uploads/Tea-Cup-Gif-Continuous.gif",
    type: "BLOG",
  },

  {
    title:
      "Empower Your Workforce with Real-Time Digital Access Through DailyPay Tips",
    image:
    "https://www.dailypay.com/wp-content/uploads/lack-of-labor.gif",
    type: "BLOG",
  },

  {
    title:
      "How Captain D’s Reduced Its Employee Turnover By 72%",
    image:
    "https://assets.dailypay.com/wp-content/uploads/digitalization-food-services.gif",
    type: "BLOG",
  },

  {
    title:
      "How Restaurants Can Support Employees Through a Possible Recession",
    image:
    "https://assets.dailypay.com/wp-content/uploads/Restaurant-Tipping-Blog-Image.png",
    type: "BLOG",
  },

  {
    title:
      "Prioritize Employee Benefits During Inflation in Restaurants and QSRs",
    image:
    "https://assets.dailypay.com/wp-content/uploads/Captain-Ds-Team2-scaled.jpg",
    type: "BLOG",
  },

  {
    title:
      "How Restaurants and QSRs May Help Employees During Supply Chain Disruptions",
    image:
    "https://assets.dailypay.com/wp-content/uploads/restaurant-potential-recession-loop.gif",
    type: "BLOG",
  },

  {
    title:
      "Restaurants Should Use On-Demand Pay to Attract and Retain Staff in a Competitive Labor Market",
    image:
    "https://assets.dailypay.com/wp-content/uploads/FEATURED-IMAGES-qst-rest-inflation-01-01.png",
    type: "BLOG",
  },
];

const EMP_RestaurantResources = () => {
  const [current, setCurrent] = useState(0);

  /* =========================
     DESKTOP
  ========================= */

  const nextDesktop = () => {
    if (current < cards.length - 4) {
      setCurrent(current + 1);
    }
  };

  const prevDesktop = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
  };

  return (
    <section className="w-full bg-[#f5f5f5] py-14 md:py-20 overflow-hidden">

      {/* =========================
          HEADING
      ========================= */}

      <div className="text-center px-4">

        <h2
          className="
            text-[#220000]
            font-serif
            font-medium
            leading-[1.1]
            text-[28px]
            sm:text-[42px]
            md:text-[52px]
            lg:text-[38px]
            lg:font-light
          "
        >
          Resources for Restaurants and QSRs
        </h2>

      </div>

      {/* =========================
          DESKTOP VIEW
      ========================= */}

      <div className="hidden lg:block relative max-w-[1500px] mx-auto mt-16 px-10">

  {/* LEFT BUTTON */}
  <button
    onClick={prevDesktop}
    className="
      absolute
      left-0
      top-1/2
      -translate-y-1/2
      z-20
      w-[54px]
      h-[54px]
      flex
      items-center
      justify-center
    "
  >
    <ChevronLeft size={34} />
  </button>

  {/* RIGHT BUTTON */}
  <button
    onClick={nextDesktop}
    className="
      absolute
      right-0
      top-1/2
      -translate-y-1/2
      z-20
      w-[54px]
      h-[54px]
      flex
      items-center
      justify-center
    "
  >
    <ChevronRight size={34} />
  </button>

  {/* CARDS */}
  <div className="overflow-hidden">

    <div
      className="
        flex
        gap-6
        transition-all
        duration-500
        ease-in-out
      "
      style={{
        transform: `translateX(-${current * 25}%)`,
      }}
    >

      {cards.map((card, index) => (
        <div
          key={index}
          className="
            min-w-[23.5%]

            bg-white
            border
            border-[#ececec]
            shadow-sm
            flex
            flex-col
          "
        >

          {/* IMAGE */}
         {/* IMAGE WRAPPER */}
<div
  className="
    w-full
    h-[230px]
    lg:h-[190px]
    bg-[#f3f3f3]
    overflow-hidden
    flex
    items-center
    justify-center
  "
>

  {/* IMAGE */}
  <div
    className="
      w-[92%]
      h-[92%]
      bg-cover
      bg-center
      transition-all
      duration-500
      hover:scale-[1.03]
    "
    style={{
      backgroundImage: `url(${card.image})`,
    }}
  ></div>

</div>

          {/* CONTENT */}
          <div className="p-6 flex flex-col flex-1">

            {/* BLOG */}
            <p
              className="
                text-black
                font-bold
                tracking-[2px]
                text-[16px]
              "
            >
              {card.type}
            </p>

            {/* TITLE */}
            <h3
              className="
                mt-5
                text-black
                font-bold
                leading-[1.45]
                text-[18px]
                font-sans
              "
            >
              {card.title}
            </h3>

          </div>

        </div>
      ))}

    </div>

  </div>
  {/* DESKTOP DOTS */}
<div className="hidden lg:flex justify-center items-center gap-3 mt-10">

  {[0, 1].map((index) => (
    <button
      key={index}
      onClick={() => setCurrent(index * 4)}
      className={`
        rounded-full
        transition-all
        duration-300

        ${
          current >= index * 4 &&
          current < (index + 1) * 4
            ? "bg-black w-[12px] h-[12px]"
            : "bg-[#cfcfcf] w-[10px] h-[10px]"
        }
      `}
    ></button>
  ))}

</div>

</div>

        

      {/* =========================
          TABLET VIEW
      ========================= */}

      <div className="hidden md:block lg:hidden mt-14 px-6">

        <div className="grid grid-cols-2 gap-6">

          {cards
            .slice(current, current + 2)
            .map((card, index) => (
              <div
                key={index}
                className="
                  bg-white
                  border
                  border-[#ececec]
                "
              >

                {/* IMAGE */}
              <div
  className="
    w-full
    lg:w-[200px]
    h-[140px]
    sm:h-[160px]
    md:h-[180px]
    lg:h-[120px]
    lg:mt-3
    bg-cover
    bg-center
  "
  style={{
    backgroundImage: `url(${card.image})`,
  }}
></div>

                {/* CONTENT */}
                <div className="p-6">

                  <p
                    className="
                      font-bold
                      tracking-[2px]
                      text-[16px]
                    "
                  >
                    BLOG
                  </p>

                  <h3
                    className="
                      mt-4
                      font-semibold
                      leading-[1.45]
                      text-[21px]
                      lg:text-[18px]
                    "
                  >
                    {card.title}
                  </h3>

                </div>

              </div>
            ))}

        </div>

        {/* DOTS */}
        <div className="flex justify-center items-center gap-3 mt-8">

          {cards.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`
                rounded-full
                transition-all
                duration-300

                ${
                  current === index
                    ? "bg-black w-[12px] h-[12px]"
                    : "bg-[#cfcfcf] w-[10px] h-[10px]"
                }
              `}
            ></button>
          ))}

        </div>

      </div>

      {/* =========================
          MOBILE VIEW
      ========================= */}

      <div className="md:hidden mt-14 px-4">

        <div
          className="
            bg-white
            border
            border-[#ececec]
          "
        >

          {/* IMAGE */}
          <div
            className="
              w-full
              h-[220px]
              bg-cover
              bg-center
            "
            style={{
              backgroundImage: `url(${cards[current].image})`,
            }}
          ></div>

          {/* CONTENT */}
          <div className="p-6">

            <p
              className="
                font-bold
                tracking-[2px]
                text-[16px]
                font-sans
              "
            >
              BLOG
            </p>

            <h3
              className="
                mt-4
                font-semibold
                leading-[1.5]
                text-[20px]
                font-sans
                text-black
              "
            >
              {cards[current].title}
            </h3>

          </div>

        </div>

        {/* DOTS */}
        <div className="flex justify-center items-center gap-3 mt-8 flex-wrap">

          {cards.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`
                rounded-full
                transition-all
                duration-300

                ${
                  current === index
                    ? "bg-black w-[12px] h-[12px]"
                    : "bg-[#cfcfcf] w-[10px] h-[10px]"
                }
              `}
            ></button>
          ))}

        </div>

      </div>

    </section>
  );
};

export default EMP_RestaurantResources;